﻿import { queries } from "@/graphql";
import { useQuery } from "@apollo/client/react";
import { useEffect } from "react";
import { enqueueSnackbar } from "notistack";

export function normalizeSettingsValue(rawValue: unknown): Record<string, any> {
  if (rawValue === null || rawValue === undefined || rawValue === "") {
    return {};
  }

  if (typeof rawValue === "object") {
    return rawValue as Record<string, any>;
  }

  if (typeof rawValue === "string") {
    try {
      const parsed = JSON.parse(rawValue);
      return typeof parsed === "object" && parsed !== null ? parsed : {};
    } catch {
      return {};
    }
  }

  return {};
}

/**
 * Custom hook to fetch the application version.
 * @returns {{settings: object, loading: boolean, error: object}} - The application settings (version), loading state, and error.
 */
export function useGetVersion() {
  const variables = {
    key: "version",
  };

  const { data, loading, error } = useQuery<{ settings?: unknown }>(
    queries.getSettings,
    {
      variables,
      errorPolicy: "all",
    },
  );

  useEffect(() => {
    if (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
    }
  }, [error]);

  return {
    settings: normalizeSettingsValue(data?.settings),
    loading,
    error,
  };
}
